/** The themes a player can switch between (each in themes/), in the order the picker shows them. */
export type Skin = "nitrate" | "manuscript" | "cyanotype" | "edition" | "phosphor";
export const SKINS: { id: Skin; name: string; hint: string }[] = [
  { id: "nitrate", name: "Nitrate", hint: "your story as a film: title cards, stills, end of reel" },
  { id: "manuscript", name: "Manuscript", hint: "printed page, your words in ink, notes in the margins" },
  { id: "cyanotype", name: "Cyanotype", hint: "printed by light: blue prints, specimens pinned" },
  { id: "edition", name: "Night Edition", hint: "you write the headlines, the narrator files the story" },
  { id: "phosphor", name: "Phosphor", hint: "amber terminal, a dithered map of where you've been" },
];
/** New players start in Manuscript (owner, 2026-10-18). A player's own choice is kept; a retired Woven choice ("loom")
 *  opens in the default. */
export const DEFAULT_SKIN: Skin = "manuscript";
